import React from 'react';
import { createBrowserRouter } from 'react-router-dom';
import { Dashboard } from './components/screens/dashboard/';
import { NotFound } from './components/screens/404/';

export const router = createBrowserRouter([
  { path: '/', element: <Dashboard />, errorElement: <NotFound /> },
]);